module.exports = __webpack_public_path__ + "img/116.b0642001.jpg";